import React from "react";
import {
  Box,
  Typography,
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const RecentBidsSection = ({ bids, theme,onRowClick }) => (
  <Card
    sx={{
      p: { xs: 3, sm: 5 }, // Adjust padding for mobile and larger screens
      mb: 8,
      borderRadius: 3,
      background: "#fff9f9",
      border: "1px solid rgba(0,0,0,0.05)",
      boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    }}
  >
    <Typography
      variant="h5"
      fontWeight={600}
      mb={3}
      sx={{
        fontSize: { xs: "1.2rem", sm: "1.5rem" }, // Adjust font size for smaller screens
      }}
    >
      Recent Bids
    </Typography>
    <Box sx={{ overflowX: "auto" }}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            {["Bid ID", "Product", "Amount", "Status", "Date"].map((h) => (
              <TableCell key={h} align="center" sx={{ fontWeight: 600 }}>
                {h}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {bids.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography variant="body2" color="text.secondary">
                  No recent bids.
                </Typography>
              </TableCell>
            </TableRow>
          ) : (
            bids.map((bid) => (
              <TableRow
                key={bid.id} style={{ cursor: "pointer" }}
                onClick={() => onRowClick(bid.productId)}
                sx={{
                  "&:hover": { backgroundColor: "rgba(0,0,0,0.02)" },
                }}
              >
                <TableCell align="center">{bid.id}</TableCell>
                <TableCell align="center">{bid.product}</TableCell>
                <TableCell align="center">{bid.amount}</TableCell>
                <TableCell align="center">
                  <Box
                    sx={{
                      background: bid.statusColor,
                      color: theme.palette.getContrastText(bid.statusColor),
                      borderRadius: 1,
                      px: 1.5,
                      py: 0.5,
                      fontWeight: 600,
                      display: "inline-block",
                    }}
                  >
                    {bid.status}
                  </Box>
                </TableCell>
                <TableCell align="center">{bid.date}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Box>
  </Card>
);

export default RecentBidsSection;
